/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
import { Button, IconButton, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Roles, translates } from '@/utils';
import { useRole } from '@/hooks/useRole';
import { Iconic } from '../iconic';

type Props<T> = {
  row: T;
  fullId: string;
  index: number;
  head: string[];
  onEdit?: any;
  isLoading?: boolean;
  editState: {
    edit: any;
    setEdit: any;
  };
};

function RowInvoice<T extends Record<string, any>>({
  row,
  onEdit,
  head,
  fullId,
  isLoading,
  editState,
}: Props<T>) {
  const { enqueueSnackbar } = useSnackbar();
  const { authorized: authorizedWithAtm } = useRole([Roles.ADMIN, Roles.ATM, Roles.SUPER_ADMIN]);

  const [change, setChange] = useState<any>({
    discount: 0,
    quantity_discount: 1,
  });

  const onSubmit = () => {
    const newMapper: any = {
      id: fullId,
    };
    Object.keys(change).forEach((key) => {
      if (key === '%' || key === 'percentageDiscount') {
        const value = Number(change[key]);
        if (value < 0 || value > 100) {
          enqueueSnackbar('Ingrese un porcentaje valido', { variant: 'error' });
        } else {
          newMapper.discount = Number(change[key]);
        }
      } else {
        newMapper[key] = Number(change[key]);
      }
    });
    onEdit?.(newMapper);
    editState.setEdit('');
  };

  return (
    <TableRow
      sx={{
        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
      }}
    >
      {Object.values(row).map((item, i) => {
        const isDiscount = head[i] === 'percentageDiscount' || head[i] === 'quantity_discount';
        return (
          <TableCell key={i}>
            {isDiscount ? (
              editState.edit === fullId ? (
                <TextField
                  InputProps={{
                    inputProps: {
                      min: 1,
                      max: 100,
                    },
                  }}
                  onChange={(value) => {
                    setChange((prev: any) => ({ ...prev, [head[i]]: value.target.value }));
                  }}
                  value={change[head[i]] ?? 0}
                  sx={{ minWidth: '50px' }}
                  type="number"
                  variant="standard"
                />
              ) : (
                item
              )
            ) : (
              item
            )}
          </TableCell>
        );
      })}
      {onEdit && (
        <TableCell>
          {editState.edit !== fullId ? (
            [
              !authorizedWithAtm ? null : (
                <Button
                  size="small"
                  onClick={() => editState.setEdit(fullId)}
                  startIcon={<Iconic icon="eva:edit-fill" />}
                  disabled={editState.edit !== fullId && editState.edit !== ''}
                >
                  {translates.edit}
                </Button>
              ),
            ]
          ) : (
            <TableContainer sx={{ flexDirection: 'row', display: 'flex' }}>
              <IconButton
                color="primary"
                onClick={() => {
                  onSubmit();
                }}
              >
                <Iconic icon="material-symbols:check-circle-outline" />
              </IconButton>
              <IconButton
                color="error"
                onClick={() => {
                  editState.setEdit('');
                  setChange({});
                }}
              >
                <Iconic icon="material-symbols:cancel-outline" />
              </IconButton>
            </TableContainer>
          )}
        </TableCell>
      )}
    </TableRow>
  );
}

export default RowInvoice;
